import { useCallback, useEffect, useState } from "react";
import {
  getEffectiveTheme,
  getStoredTheme,
  initTheme,
  setTheme,
  toggleTheme,
} from "../utils/theme";

export function useTheme() {
  const [theme, setThemeState] = useState(getEffectiveTheme);

  useEffect(() => {
    initTheme();
    setThemeState(getEffectiveTheme());

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleSystemThemeChange = () => {
      if (!getStoredTheme()) {
        setThemeState(getEffectiveTheme());
      }
    };

    mediaQuery.addEventListener("change", handleSystemThemeChange);
    return () =>
      mediaQuery.removeEventListener("change", handleSystemThemeChange);
  }, []);

  const setAppTheme = useCallback((nextTheme) => {
    setTheme(nextTheme);
    setThemeState(nextTheme);
  }, []);

  const toggleAppTheme = useCallback(() => {
    setThemeState((currentTheme) => toggleTheme(currentTheme));
  }, []);

  return {
    theme,
    isDark: theme === "dark",
    setTheme: setAppTheme,
    toggleTheme: toggleAppTheme,
  };
}
